module.exports = __webpack_public_path__ + "img/n2.a6656312.jpg";